import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function usePresence(user: any) {
  useEffect(() => {
    if (!user) return;

    const updatePresence = () => {
      supabase
        .from('profiles')
        .update({ is_online: true, last_seen: new Date().toISOString() } as any)
        .eq('user_id', user.id);
    };

    updatePresence();
    const interval = setInterval(updatePresence, 60000);

    const handleVisibility = () => {
      if (document.hidden) {
        supabase
          .from('profiles')
          .update({ is_online: false, last_seen: new Date().toISOString() } as any)
          .eq('user_id', user.id);
      } else {
        updatePresence();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
      supabase
        .from('profiles')
        .update({ is_online: false, last_seen: new Date().toISOString() } as any)
        .eq('user_id', user.id);
    };
  }, [user]);
}
